class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    const closeButton = this.querySelector('button[type="button"].search-modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.close();
        this.detailsContainer.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');
      });
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.isOpen()) {
      this.close();
      this.detailsContainer.removeAttribute('open');
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  }

  open(event) {
  // ✅ Close other <details-modal> components
    document.querySelectorAll('details-modal').forEach((modalEl) => {
      if (modalEl !== this && modalEl.isOpen()) {
        modalEl.close();
        const details = modalEl.querySelector('details');
        if (details) {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.removeAttribute('aria-expanded');
        }
        document.body.removeEventListener('click', modalEl.onBodyClickEvent);
      }
    });

    // ✅ Close standalone <details open> elements outside this modal
    document.querySelectorAll('details[open]').forEach((detailsEl) => {
      if (!this.contains(detailsEl)) {
        detailsEl.removeAttribute('open');
        const summary = detailsEl.querySelector('summary');
        if (summary) summary.removeAttribute('aria-expanded');
      }
    });

    // ✅ Open this modal
    this.detailsContainer.setAttribute('open', true);
    const thisSummary = this.detailsContainer.querySelector('summary');
    if (thisSummary) thisSummary.setAttribute('aria-expanded', 'true');

    this.onBodyClickEvent = this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    const summary = this.detailsContainer.querySelector('summary');
    if (summary) summary.removeAttribute('aria-expanded');

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
